import { createFileRoute } from "@tanstack/react-router";
import { VehiclesSitemapRedirect } from "@/components/layout/VehiclesSitemapRedirect";

export const Route = createFileRoute("/sitemap-vehicle.xml/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VehiclesSitemapRedirect />
  );
}
